class StickyHeader {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
    }

    onInit () {
        // Init last scroll to top to 0
        let lastScrollTop = 0
        // Get all elements with data attribute
        const stickyHeaders = document.querySelectorAll('[data-sticky-header]')
        // Loop through each element, register a scroll event listener
        stickyHeaders.forEach(header => {
            window.addEventListener('scroll', e => {
                let stickyOffset = header.offsetTop + header.offsetHeight
                let amountScrolled = window.pageYOffset || document.documentElement.scrollTop
                if (amountScrolled >= stickyOffset) {
                    header.classList.add('sticky')
                    document.getElementsByTagName('BODY')[0].style.paddingTop = `${header.offsetHeight}px`
                    if (amountScrolled > lastScrollTop) {
                        document.body.classList.remove('sticky-header')
                    } else {
                        // header.classList.add('sticky--active')
                        document.body.classList.add('sticky-header')
                    }
                } else {
                    header.classList.remove('sticky')
                    document.body.classList.remove('sticky-header')
                    document.getElementsByTagName('BODY')[0].style.paddingTop = '0px'
                }
                lastScrollTop = amountScrolled <= 0 ? 0 : amountScrolled // For Mobile or negative scrolling
            }, false)
        })
    }
}

export default StickyHeader



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StickyHeader.js